import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import ListService from "../../../components/service/admin/listService";
import Header from "../../../partials/header";
import { styles } from "./styles";

class Service extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
    };
  }
  handleSearch = (e) => {
    const _this = this;
    this.setState(
      {
        search: e.target.value,
      },
      function () {
        _this.mList.getList();
      }
    );
  };
  addNewSpa = () => {
    this.props.history.push("/service-admin/add");
  };
  render() {
    const { search } = this.state;
    const { classes, t, ...props } = this.props;
    return (
      <>
        <Header
          session={t("sidebar_superadmin")}
          title={t("service_admin_list_services")}
          button={t("service_admin_list_services_add_new_spa")}
          actionButton={this.addNewSpa}
        />
        {/* <div className={classes.frameTitle}>
                    <Typography variant="h4">{t('service_admin_list_services')}</Typography>
                    <div className={classes.boxAction}>
                        <div className={classes.search}>
                            <div className={classes.searchIcon}>
                                <SearchIcon />
                            </div>
                            <InputBase
                                placeholder={t("search")}
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                                value={search}
                                onChange={this.handleSearch}
                            />
                        </div>
                        <div className={classes.iconButton}>
                            <Link to='/service-admin/add'><IconButton className={classes.iconWrap} aria-label="Add">
                                <Icon className={classes.icon} color="disabled" > add_circle </Icon>
                            </IconButton></Link>
                        </div>
                    </div>
                </div> */}
        <ListService
          onRef={(ref) => (this.mList = ref)}
          {...props}
          search={search}
        />
      </>
    );
  }
}

Service.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  adminService: state.service.adminService,
  role: state.user.user.roleId.role,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Service)));
